const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};



document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll('.jdgm-prev-badge__text');
    elements.forEach(function(element) {
        if (element.textContent.trim() === "No reviews") {
            element.style.display = 'none';
        } else {
            element.style.display = 'none';
        }
    });
});

